import { useContext, useEffect } from "react";
import Loader from "../../components/UI/Loader";
import { ADMIN_ROLE_ID } from "../../constants/userRoles";
import { Link } from "react-router-dom";
import { MeContext } from "../../App";

const TrialEnded = () => {
    const me = useContext(MeContext);

    useEffect(() => {
        document.title = 'Trial Ended';
    }, []);

    if (me.loading) {
        return <Loader />
    }

    return <section id="trial-ended-section">
        <div className="row justify-content-center">
            <div className="column-medium-6 border margin-top-5 rounded padding-5">
                <h1>Trial Ended</h1>
                <p>Your organization's trial has ended.</p>
                {me.user?.userRoleId === ADMIN_ROLE_ID && <p>If you'd like to continue using countbubble please <Link to="/admin/billing">upgrade</Link> your plan</p>}
                {me.user?.userRoleId !== ADMIN_ROLE_ID && <p>If you'd like to continue using countbubble please have an Admin upgrade your plan</p>}
                <p>If you need any assistance please contact support at <a className='email-link' href="mailto:contact@countbubble.com?subject=Access Denied">contact@countbubble.com</a></p>
            </div>
        </div>
    </section>;
};

export default TrialEnded;